import { useEffect, useState, useContext } from "react";
import API from "../api/api";
import { UserContext } from "../context/UserContext";
import { AlertContext } from "../context/AlertContext";
import PartidosFaseGrupos from "./PartidosFaseGrupos";
import Cards from "./components/Cards";
import { getCardState } from "./components/utils/matchLogic";
import { Fase } from "../shared/multiplicadores";
import "../css/EliminatoriaCompartida.css";

interface Equipo {
  nombre: string;
  bandera: string;
  grupo: string;
}

interface Partido {
  id: number;
  local: Equipo;
  visitante: Equipo;
  goles_local: number | null;
  goles_visitante: number | null;
  fecha: string;
}



interface Props {
  fase: Fase;              
  titulo: string;
  endpoint: string;
  fechaPrimerPartido: string;
}

const EliminatoriaCompartida = ({
  fase,
  titulo,
  endpoint,
  fechaPrimerPartido,
}: Props) => {
  const { user, refreshUser } = useContext(UserContext)!;
  const { showAlert } = useContext(AlertContext)!;

  const [bracket, setBracket] = useState<Partido[]>([]);
  const [predicciones, setPredicciones] = useState<any[]>([]);
  const [partidoSeleccionado, setPartidoSeleccionado] = useState<any>(null);




  const obtenerPrediccion = (id: number) =>
    predicciones.find(p => p.id_partido === id);

  useEffect(() => {
    API.get(endpoint).then(res => {
      setBracket(
        res.data.map((p: any) => ({
          id: p.id,
          fecha: p.fecha,
          local: {
            nombre: p.local_nombre,
            bandera: p.local_bandera.replace(/\..+$/, ""),
            grupo: p.local_grupo,
          },
          visitante: {
            nombre: p.visitante_nombre,
            bandera: p.visitante_bandera.replace(/\..+$/, ""),
            grupo: p.visitante_grupo,
          },
          goles_local: p.goles_local,
          goles_visitante: p.goles_visitante,
        }))
      );
    });
  }, [endpoint]);

  useEffect(() => {
    if (!user) return;
    API.get(`/predicciones?id_usuario=${user.id}`)
      .then(res => setPredicciones(res.data));
  }, [user?.id]);

  const guardarPrediccion = async (
  gl: number,
  gv: number,
  apuesta: number
) => {
  if (!user || !partidoSeleccionado) return;

  await API.post("/predicciones", {
    id_usuario: user.id,
    id_partido: partidoSeleccionado.id,
    prediccion_local: gl,
    prediccion_visitante: gv,
    apuesta,
    fase,
  });

  // 🔥 ESTO ES LO QUE FALTABA
  const res = await API.get(`/predicciones?id_usuario=${user.id}`);
  setPredicciones(res.data);

  await refreshUser?.();
  setPartidoSeleccionado(null);
};


  // ⏰ bloqueo por fecha
const HORAS_BLOQUEO = 3;
const fechaInicioFase = new Date(fechaPrimerPartido);

const fechaBloqueoFase = new Date(
  fechaInicioFase.getTime() - HORAS_BLOQUEO * 60 * 60 * 1000
);
const prediccionesBloqueadas = new Date() >= fechaBloqueoFase;




  return (
    <section className="eliminatorias-container">
      <h2>{titulo}</h2>

      {prediccionesBloqueadas && (
        <div className="predicciones-cerradas">
          🔒 Predicciones cerradas para esta fase
        </div>
      )}


      <div className="grupo-grid">
        {bracket.map(p => {
          const pred = obtenerPrediccion(p.id);
          const state = getCardState(p, pred);          
          const puedeMostrarBoton =
          !!user &&
          !prediccionesBloqueadas &&
          p.goles_local == null &&
          p.goles_visitante == null;
                  


          return (
            <Cards
              key={p.id}
              partido={{
                ...p,
                local_nombre: p.local.nombre,
                visitante_nombre: p.visitante.nombre,
                local_bandera: p.local.bandera,
                visitante_bandera: p.visitante.bandera,
                local_grupo: p.local.grupo,
                visitante_grupo: p.visitante.grupo,
              }}
              pred={pred}
              state={state}
              fase={fase}
              usuarioLogueado={!!user}
              
              puedePredecir={puedeMostrarBoton}
              onPredecir={() => setPartidoSeleccionado(p)}
              onEditar={() => setPartidoSeleccionado(p)}
            />

          );
        })}
      </div>

      {partidoSeleccionado && (
        <PartidosFaseGrupos
          partido={{
            id: partidoSeleccionado.id,
            local_nombre: partidoSeleccionado.local.nombre,
            visitante_nombre: partidoSeleccionado.visitante.nombre,
            goles_local: partidoSeleccionado.goles_local,
            goles_visitante: partidoSeleccionado.goles_visitante,
            fecha: new Date().toISOString(),
          }}
          fase={fase}
          prediccion={obtenerPrediccion(partidoSeleccionado.id)}
          puntosDisponibles={user?.puntos ?? 0}
          guardando={false}
          onClose={() => setPartidoSeleccionado(null)}
          onSave={guardarPrediccion}
        />
      )}
    </section>
  );
};

export default EliminatoriaCompartida;
